<template>
	<div class="section">
		<div class="container" id="opportunities">
			<p>
				<span style="color: red;">NEW!</span> Post details about an open search that will be visible only to BlueSteps members. Once reviewed and approved by AESC staff, potential candidates can come to you, helping streamline the sourcing process. <strong>Click "Add Opportunity" to get started.</strong> Email <a href="mailto:accessbluesteps@aesc.org">accessbluesteps@aesc.org</a> with any questions about this new feature.
			</p>
			<div class="level">
				<div class="level-left">
					<div class="level-item">
						<b-input v-model="filter" placeholder="Type a filter here..."></b-input>
					</div>
					<div class="level-item">
						<b-checkbox v-model="showBSDB">BSDB</b-checkbox>
						<b-checkbox v-model="showMobius">Mobius RSS</b-checkbox>
						<b-checkbox v-model="showGroups">Automated Groups</b-checkbox>
					</div>
				</div>
				<div class="level-right">
					<div class="level-item">
						<a class="btn cta-yellow" @click="addEditOpp({})">Add Opportunity</a>
					</div>
				</div>
			</div>
			<b-table :data="filteredOpportunities"
					 :default-sort="['Status', 'desc']"
					 hoverable
					 mobile-cards
					 paginated
					 :loading="isLoading"
					 :per-page="10"
					 pagination-simple>
				<template>
					<b-table-column field="Title" label="Title" sortable v-slot="props">
						<a @click="addEditOpp(props.row)">{{ props.row.Title }}</a>
					</b-table-column>
					<b-table-column field="PubDate" label="Post Date" sortable v-slot="props">
						{{ props.row.PubDate | moment('MM/DD/YYYY') }}
					</b-table-column>
					<b-table-column field="SearchFirmClientOrganizationName" label="Company" sortable v-slot="props">
						{{ props.row.SearchFirmClientOrganizationName }}
					</b-table-column>
					<b-table-column field="SearchFirmName" label="Search Firm" sortable v-slot="props">
						{{ props.row.SearchFirmName }}
					</b-table-column>
					<b-table-column field="Status" label="Status" sortable v-slot="props">
						<b-select v-model="props.row.Status" @input="updateOpportunity(props.row)">
							<option v-for="s in statuses" :value="s.Name">{{ s.Name }}</option>
						</b-select>
					</b-table-column>
				</template>
			</b-table>
		</div>
	</div>
</template>

<script>
	import addEditOpp from "@/components/modals/addEditOpp.vue";
	export default {
		data() {
			return {
				filter: '',
				showBSDB: true,
				showMobius: true,
				showGroups: false,
				opportunities: [],
				isLoading: false,
				statuses: []
			}
		},
		created() {
			this.getOpportunities();
		},
		computed: {
			filteredOpportunities() {
				let opps = [];

				if (this.showBSDB) {
					opps = [...opps, ...this.opportunities.filter(opp => !!opp.MemberId)];
				}
				if (this.showMobius) {
					opps = [...opps, ...this.opportunities.filter(opp => opp.CreatedByName === "mobius")];
				}
				if (this.showGroups) {
					const authors = ["Indeed", "CareerBuilder"];
					opps = [...opps, ...this.opportunities.filter(opp => authors.indexOf(opp.CreatedByName) > -1)];
				}

				return opps.filter((option) => {
					if (option.Title.toString().toLowerCase().indexOf(this.filter.toLowerCase()) >= 0) {
						return option
							.Title
							.toString()
							.toLowerCase()
							.indexOf(this.filter.toLowerCase()) >= 0;
					} else if (option.SearchFirmClientOrganizationName.toString().toLowerCase().indexOf(this.filter.toLowerCase()) >= 0) {
						return option
							.SearchFirmClientOrganizationName
							.toString()
							.toLowerCase()
							.indexOf(this.filter.toLowerCase()) >= 0;
					} else if (option.SearchFirmName.toString().toLowerCase().indexOf(this.filter.toLowerCase()) >= 0) {
						return option
							.SearchFirmName
							.toString()
							.toLowerCase()
							.indexOf(this.filter.toLowerCase()) >= 0;
					} else if (option.Status.toString().toLowerCase().indexOf(this.filter.toLowerCase()) >= 0) {
						return option
							.Status
							.toString()
							.toLowerCase()
							.indexOf(this.filter.toLowerCase()) >= 0;
					}
				});

			}
		},
		methods: {
			updateOpportunity(opp) {
				this.$http.post("api/opportunity/status", { Id: opp.Id, Status: opp.Status })
					.then(resp => {
						this.$buefy.toast.open(resp.data);
					}).catch(err => {
						console.log(err);
					})
			},
			addEditOpp(opp) {
				this.$buefy.modal.open({
					parent: this,
					component: addEditOpp,
					hasModalCard: true,
					fullScreen: true,
					props: {
						Opportunity: opp
					},
					events: {
						'getOpps': async () => {
							await this.getOpportunities();
						},
						'saved': (opp) => {
							this.getOpportunities();
						}
					}
				})
			},
			getOpportunities() {
				this.isLoading = true;
				this.$http.get("api/opportunity")
					.then(resp => {
						if (resp.data != null) {
							this.opportunities = resp.data.Opportunities;
							this.statuses = resp.data.Statuses;
						}
						else {
							this.$buefy.toast.open("Could not get opportunities.");
						}
						this.isLoading = false;
					}).catch(err => {
						this.isLoading = false;
						this.$buefy.toast.open("Could not get opportunities.");
					})
			}
		}
	}
</script>

<style>

	#opportunities table th {
		color: #2F4E6F !important;
	}
</style>
